var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Add Access Host ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "form",
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  name: "Host",
                  label: "Host",
                  placeholder: "% wildcard is allowed",
                  "error-messages": _vm.errors.collect("Host")
                },
                model: {
                  value: _vm.host,
                  callback: function callback($$v) {
                    _vm.host = $$v
                  },
                  expression: "host"
                }
              })
            ],
            1
          ),
          _c(
            "gg-btn",
            {
              attrs: {
                dark: "",
                loading: _vm.loading
              },
              on: {
                click: _vm.addHost
              }
            },
            [_vm._v("Add Host")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }